import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import classNamesBind from 'classnames/bind';

import s from './Spreader.scss';

const cx = classNamesBind.bind(s);

class Spreader extends React.PureComponent {
  constructor(props, ctx) {
    super(props, ctx);
  }

  render() {
    const {
      fixed,
      className,
      paddingLeft,
      paddingRight,
      paddings,
      mobileWide,
      extraWide,
      wideRight,
      children,
      theme,
      ...restProps
    } = this.props;

    const cls = classNames(
      className,
      cx('spreader', {
        'spreader--fixed': Boolean(fixed),
        'spreader--extra-wide': Boolean(extraWide),
        [`spreader--${theme}`]: Boolean(theme),
        'spreader--padding-left': Boolean(paddingLeft),
        'spreader--padding-right': Boolean(paddingRight),
        'spreader--paddings': Boolean(paddings),
        'spreader--wide-right': Boolean(wideRight),
        'spreader--mobile-wide': Boolean(mobileWide),
      })
    );

    return (
      <div className={cls} {...restProps}>
        {children}
      </div>
    );
  }
}

export default Spreader;
